<template>
    <div class="news-container">
        <el-card class="box-card">
            <!-- 搜索区域 -->

            <!-- 标签页 -->
            <el-tabs v-model="activeTab" @tab-click="handleTabClick">
                <div class="filter-container">
                    <el-input
                        v-model="queryParams.title"
                        placeholder="请输入标题"
                        style="width: 200px"
                        class="filter-item"
                        @keyup.enter.native="handleQuery"
                        clearable
                    />
                    <el-button
                        class="filter-item"
                        type="primary"
                        @click="handleQuery"
                        >查询</el-button
                    >
                    <el-button
                        class="filter-item"
                        @click="resetQuery"
                        >重置</el-button
                    >
                    <el-button
                        class="filter-item"
                        type="primary"
                        @click="handleAdd"
                        >新增</el-button
                    >
                    <el-button
                        class="filter-item"
                        type="danger"
                        @click="handleBatchDelete"
                        >批量删除</el-button
                    >
                </div>
                <el-tab-pane label="平台新闻" name="news">
                    <!-- 新闻列表 -->
                    <el-table
                        :data="tableData"
                        style="width: 100%"
                        border
                        v-loading="loading"
                        @selection-change="handleSelectionChange"
                    >
                        <el-table-column
                            type="selection"
                            width="50"
                            align="center"
                        />
                        <el-table-column
                            type="index"
                            label="序号"
                            width="50"
                            align="center"
                        />
                        <el-table-column
                            prop="title"
                            label="标题"
                            min-width="200"
                        />
                        <el-table-column
                            prop="content"
                            label="内容缩略"
                            min-width="300"
                            :show-overflow-tooltip="true"
                        >
                            <template slot-scope="scope">
                                <span
                                    >{{
                                        scope.row.content
                                            .replace(/<[^>]+>/g, "")
                                            .slice(0, 100)
                                    }}{{
                                        scope.row.content.length > 100
                                            ? "..."
                                            : ""
                                    }}</span
                                >
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="createTime"
                            label="添加时间"
                            width="180"
                            align="center"
                        />
                        <el-table-column
                            label="操作"
                            width="150"
                            align="center"
                        >
                            <template slot-scope="scope">
                                <el-button
                                    type="text"
                                    @click="handleEdit(scope.row)"
                                    >编辑</el-button
                                >
                                <el-button
                                    type="text"
                                    style="color: #ff0000"
                                    @click="handleDelete(scope.row)"
                                    >删除</el-button
                                >
                            </template>
                        </el-table-column>
                    </el-table>

                    <!-- 分页 -->
                    <div class="pagination-container">
                        <el-pagination
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="queryParams.current"
                            :page-sizes="[10, 20, 30, 50]"
                            :page-size="queryParams.size"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="total"
                        />
                    </div>
                </el-tab-pane>

                <el-tab-pane label="重要公告" name="announcement">
                    <!-- 公告列表，结构同新闻列表 -->
                    <el-table
                        :data="tableData"
                        style="width: 100%"
                        border
                        v-loading="loading"
                        @selection-change="handleSelectionChange"
                    >
                        <el-table-column
                            type="selection"
                            width="50"
                            align="center"
                        />
                        <el-table-column
                            type="index"
                            label="序号"
                            width="50"
                            align="center"
                        />
                        <el-table-column
                            prop="title"
                            label="标题"
                            min-width="200"
                        />
                        <el-table-column
                            prop="content"
                            label="公告内容"
                            min-width="300"
                            :show-overflow-tooltip="true"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="createTime"
                            label="添加时间"
                            width="180"
                            align="center"
                        />
                        <el-table-column
                            label="操作"
                            width="150"
                            align="center"
                        >
                            <template slot-scope="scope">
                                <el-button
                                    type="text"
                                    @click="handleEdit(scope.row)"
                                    >编辑</el-button
                                >
                                <el-button
                                    type="text"
                                    style="color: #ff0000"
                                    @click="handleDelete(scope.row)"
                                    >删除</el-button
                                >
                            </template>
                        </el-table-column>
                    </el-table>

                    <!-- 分页 -->
                    <div class="pagination-container">
                        <el-pagination
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="queryParams.current"
                            :page-sizes="[10, 20, 30, 50]"
                            :page-size="queryParams.size"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="total"
                        />
                    </div>
                </el-tab-pane>
            </el-tabs>
        </el-card>
        <!-- 新增/编辑弹框 -->
        <el-dialog
            :title="dialogTitle"
            :visible.sync="dialogVisible"
            width="70%"
            @close="cancelForm"
        >
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
                <el-form-item label="标题" prop="title">
                    <el-input
                        v-model="form.title"
                        placeholder="请输入标题"
                    ></el-input>
                </el-form-item>
                <el-form-item label="内容" prop="content">
                    <div class="editor-container">
                        <EditorDom :value.sync="form.content"></EditorDom>
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelForm">取 消</el-button>
                <el-button type="primary" @click="submitForm">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog
            :title="dialogTitle1"
            :visible.sync="dialogVisible1"
            width="700px"
            @close="cancelForm1"
        >
            <el-form
                ref="form1"
                :model="form1"
                :rules="rules1"
                label-width="80px"
            >
                <el-form-item label="标题" prop="title">
                    <el-input
                        v-model="form1.title"
                        placeholder="请输入标题"
                    ></el-input>
                </el-form-item>
                <el-form-item label="内容" prop="content">
                    <el-input
                        type="textarea"
                        :autosize="{ minRows: 2, maxRows: 10 }"
                        placeholder="请输入内容"
                        v-model="form1.content"
                        maxlength="100"
                        show-word-limit
                    >
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelForm1">取 消</el-button>
                <el-button type="primary" @click="submitForm1">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import EditorDom from "@/components/Editor.vue";
import {
    newsPage,
    newsSave,
    newsUpdate,
    newsRemove,
    announcementPage,
    announcementSave,
    announcementUpdate,
    announcementRemove,
} from "@/api/admin.js";
export default {
    name: "News",
    components: {
        EditorDom,
    },
    data() {
        return {
            // 加载状态
            loading: false,
            // 激活的标签页
            activeTab: "news",
            // 查询参数
            queryParams: {
                current: 1,
                size: 10,
            },
            // 总条数
            total: 0,
            // 表格数据
            tableData: [],
            // 弹框显示状态
            dialogVisible: false,
            dialogVisible1: false,
            // 弹框标题
            dialogTitle: "",
            dialogTitle1: "",
            // 选中的行数据
            selectedRows: [],
            // 表单数据
            form: {
                id: undefined,
                title: "",
                content: "",
                type: "news",
            },
            // 表单校验规则
            rules: {
                title: [
                    { required: true, message: "请输入标题", trigger: "blur" },
                ],
                content: [
                    { required: true, message: "请输入内容", trigger: "blur" },
                ],
            },
            form1: {
                id: undefined,
                title: "",
                content: "",
                type: "news",
            },
            // 表单校验规则
            rules1: {
                title: [
                    { required: true, message: "请输入标题", trigger: "blur" },
                ],
                content: [
                    { required: true, message: "请输入内容", trigger: "blur" },
                ],
            },
        };
    },
    created() {
        this.getList();
    },
    methods: {
        // 获取列表数据
        getList() {
            this.loading = true;
            // TODO: 调用接口获取数据
            if (this.activeTab === "news") {
                newsPage(this.queryParams)
                    .then((res) => {
                        this.tableData = res.data.records;
                        this.total = res.data.total;
                        this.loading = false;
                    })
                    .catch(() => {
                        this.loading = false;
                    });
            } else {
                announcementPage(this.queryParams)
                    .then((res) => {
                        this.tableData = res.data.records;
                        this.total = res.data.total;
                        this.loading = false;
                    })
                    .catch(() => {
                        this.loading = false;
                    });
            }
            // setTimeout(() => {
            //     this.tableData = [
            //         {
            //             id: 1,
            //             title: "示例新闻标题",
            //             content:
            //                 "这是一段示例新闻内容，展示了新闻列表的基本功能和样式。",
            //             createTime: "2024-01-20 10:00:00",
            //         },
            //     ];
            //     this.total = 1;
            //     this.loading = false;
            // }, 500);
        },
        // 查询按钮点击
        handleQuery() {
            this.queryParams.current = 1;
            this.getList();
        },
        // 重置按钮点击
        resetQuery() {
            this.queryParams = {
                current: 1,
                size: 10,
                title: undefined
            };
            this.getList();
        },
        // 表格多选框选中数据
        handleSelectionChange(selection) {
            this.selectedRows = selection;
        },
        // 批量删除
        handleBatchDelete() {
            if (this.selectedRows.length === 0) {
                this.$message.warning("请至少选择一条记录");
                return;
            }
            
            this.$confirm(`确认删除已选中的 ${this.selectedRows.length} 条记录吗?`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                const ids = this.selectedRows.map(row => row.id).join(",");
                
                if (this.activeTab === "news") {
                    newsRemove(ids)
                        .then(() => {
                            this.$message.success("批量删除成功");
                            this.getList();
                            this.selectedRows = [];
                        })
                        .catch(() => {
                            this.$message.error("批量删除失败");
                        });
                } else {
                    announcementRemove(ids)
                        .then(() => {
                            this.$message.success("批量删除成功");
                            this.getList();
                            this.selectedRows = [];
                        })
                        .catch(() => {
                            this.$message.error("批量删除失败");
                        });
                }
            }).catch(() => {
                // 用户取消删除
            });
        },
        // 新增按钮点击
        handleAdd() {
            if (this.activeTab === "news") {
                this.dialogTitle = "新增新闻";
                this.form = {
                    id: undefined,
                    title: "",
                    content: "",
                    type: this.activeTab,
                };
                this.dialogVisible = true;
            } else {
                this.dialogTitle1 = "新增公告";
                this.form1 = {
                    id: undefined,
                    title: "",
                    content: "",
                    type: this.activeTab,
                };
                this.dialogVisible1 = true;
            }
        },
        // 编辑按钮点击
        handleEdit(row) {
            if (this.activeTab === "news") {
                this.dialogTitle = "编辑新闻";
                this.form = {
                    ...row,
                };
                this.dialogVisible = true;
            } else {
                this.dialogTitle1 = "编辑公告";
                this.form1 = {
                    ...row,
                };
                this.dialogVisible1 = true;
            }
        },
        // 提交表单
        submitForm() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    // TODO: 调用接口保存数据
                    if (this.form.id) {
                        newsUpdate(this.form)
                            .then((res) => {
                                this.$message.success("保存成功");
                                this.dialogVisible = false;
                                this.getList();
                            })
                            .catch(() => {
                                this.$message.error("保存失败");
                            });
                    } else {
                        newsSave(this.form)
                            .then((res) => {
                                this.$message.success("保存成功");
                                this.dialogVisible = false;
                                this.getList();
                            })
                            .catch(() => {
                                this.$message.error("保存失败");
                            });
                    }
                }
            });
        },
        // 取消提交
        cancelForm() {
            this.dialogVisible = false;
            this.$refs.form.resetFields();
        },
        // 提交表单
        submitForm1() {
            this.$refs.form1.validate((valid) => {
                if (valid) {
                    if (this.form1.id) {
                        announcementUpdate(this.form1)
                            .then(() => {
                                this.$message.success("保存成功");
                                this.dialogVisible1 = false;
                                this.getList();
                            })
                            .catch(() => {
                                this.$message.error("保存失败");
                            });
                    } else {
                        announcementSave(this.form1)
                            .then(() => {
                                this.$message.success("保存成功");
                                this.dialogVisible1 = false;
                                this.getList();
                            })
                            .catch(() => {
                                this.$message.error("保存失败");
                            });
                    }
                }
            });
        },
        // 取消提交
        cancelForm1() {
            this.dialogVisible1 = false;
            this.$refs.form1.resetFields();
        },
        // 删除按钮点击
        handleDelete(row) {
            this.$confirm("确认删除该条记录?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    if (this.activeTab === "news") {
                        newsRemove(row.id)
                            .then(() => {
                                this.$message.success("删除成功");
                                this.getList();
                            })
                            .catch(() => {
                                this.$message.error("删除失败");
                            });
                    } else {
                        announcementRemove(row.id)
                            .then(() => {
                                this.$message.success("删除成功");
                                this.getList();
                            })
                            .catch(() => {
                                this.$message.error("删除失败");
                            });
                    }
                })
                .catch(() => {
                    // this.$message.info("已取消删除");
                });
        },
        // 标签页切换
        handleTabClick(tab) {
            this.getList();
        },
        // 每页条数改变
        handleSizeChange(val) {
            this.queryParams.size = val;
            this.getList();
        },
        // 当前页改变
        handleCurrentChange(val) {
            this.queryParams.current = val;
            this.getList();
        },
    },
};
</script>

<style lang="scss" scoped>
.news-container {
    /* padding: 20px; */

    .filter-container {
        display: flex;
        margin-bottom: 20px;
        .filter-item {
            margin-right: 10px;
        }
    }

    .pagination-container {
        margin-top: 20px;
        text-align: right;
    }
}
</style>
